import locationSetupService from 'Services/api/onsiteSetup.service'
import { LocationSetupContract } from 'models'

import { AppThunk, fetchWithNotification } from './base.action'

export const FETCH_LOCATION_SETUP_START = 'FETCH_LOCATION_SETUP_START'

export const FETCH_LOCATION_SETUP_FAILED = 'FETCH_LOCATION_SETUP_FAILED'

export const FETCH_LOCATION_SETUP_SUCCESS = 'FETCH_LOCATION_SETUP_SUCCESS'

export const GET_INSTALLATION_PIN_START = 'GET_INSTALLATION_PIN_START'
export const GET_INSTALLATION_PIN_SUCCESS = 'GET_INSTALLATION_PIN_SUCCESS'
export const GET_INSTALLATION_PIN_FAILED = 'GET_INSTALLATION_PIN_FAILED'

export const CLEAR_INSTALLATION_PIN = 'CLEAR_INSTALLATION_PIN'

export const fetchLocationSetupStart = () => ({
    type: FETCH_LOCATION_SETUP_START,
})

export const fetchLocationSetupSuccess = (
    payload: LocationSetupContract[],
) => ({
    type: FETCH_LOCATION_SETUP_SUCCESS,
    payload,
})

export const fetchLocationSetupFailed = (error: any) => ({
    type: FETCH_LOCATION_SETUP_FAILED,
    payload: error,
})

export function fetchLocationSetup(): AppThunk {
    return async (dispatch) => {
        dispatch(fetchLocationSetupStart())
        try {
            const res = await fetchWithNotification({
                apiLinkFnc: locationSetupService.getToGetLocationSetups,
            })
            dispatch(fetchLocationSetupSuccess(res.data))
        } catch (error) {
            dispatch(fetchLocationSetupFailed(error))
        }
    }
}

export const getInstallationPinStart = () => ({
    type: GET_INSTALLATION_PIN_START,
})

export const getInstallationPinSuccess = (payload: LocationSetupContract) => ({
    type: GET_INSTALLATION_PIN_SUCCESS,
    payload,
})

export const getInstallationPinFailed = (error: any) => ({
    type: GET_INSTALLATION_PIN_FAILED,
    payload: error,
})

export function getInstallationPin(locationTenantID: string): AppThunk {
    return async (dispatch) => {
        dispatch(getInstallationPinStart())
        try {
            const res = await fetchWithNotification({
                apiLinkFnc: () =>
                    locationSetupService.postGenerateSetup(locationTenantID),
            })
            dispatch(getInstallationPinSuccess(res.data))
        } catch (error) {
            dispatch(getInstallationPinFailed(error))
        }
    }
}
